import { FirebaseActions, FirebaseSelectors } from '@web_opxp/features';
import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { IState } from '../store/state';
import { getProductsObFlowConfig, getProductsVariantConfig } from './utils';

export interface ISplitTestWrapperProps {
  ready: boolean;
  onTrack: (variant: string | number) => void;
}

export const mapStateToProps = (state: IState) => {
  const ready = FirebaseSelectors.isReady(state);
  return {
    ready,
  };
};

export const mapDispatchToProps = {
  onTrack: (variant: string | number) => FirebaseActions.setUserPropertyAction('experiment_4487', variant),
};

// this component is implemented as a wrapper and needs to be used explicitly
// the reason for that is that we can easily remove this wrapper when experiment is done
export const SplitTestWrapperFC: FC<React.PropsWithChildren<ISplitTestWrapperProps>> = ({
  ready,
  children,
  onTrack,
}) => {
  const obFlow = ready && getProductsObFlowConfig();
  const subscribeVariant = ready ? getProductsVariantConfig() : undefined;
  useEffect(() => {
    if (!ready || !subscribeVariant) {
      return;
    }
    // trigger property tracking regardless of the skip premium visibility setting
    onTrack(subscribeVariant);
  }, [ready, obFlow, subscribeVariant, onTrack]);

  if (!obFlow) {
    return null;
  }

  return children;
};

export const SplitTestWrapper = connect(mapStateToProps, mapDispatchToProps)(SplitTestWrapperFC);
export default SplitTestWrapper;
